import { render, staticRenderFns } from "./DetailStacked.vue?vue&type=template&id=a44876f6"
import script from "./DetailStacked.vue?vue&type=script&lang=js"
export * from "./DetailStacked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports